<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h2 class="title_page">MY PAGE</h2>
            <div class="mypage_area">
                <ul class="sub_link_list">
                    <li class="on">
                        <RouterLink to="/HFO_MP_003">1:1 문의 내역</RouterLink>
                    </li>
                    <li>
                        <RouterLink to="/HFO_MP_005">개인정보관리</RouterLink>
                    </li>
                </ul>

                <div class="q_detail_area">
                    <div class="notice_view_area">
                    </div>

                    <!-- 답변 영역 -->
                    <div class="admin_answer_area">
                        <div class="admin_answer_top">
                            <strong>[답변 완료] {{ qnaTitle }}</strong>
                            <p>답변일: {{ replyDt }}</p>
                        </div>

                        <div class="admin_answer_contents">
                            {{ replyRmks }}

                            <div class="content-separator">
                                <div class="separator-line"></div>
                            </div>

                            <div class="original-question">
                                {{ qnaRmks }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="btn_write_area">
                    <RouterLink to="/HFO_MP_003" class="btn_type2">목록 보기</RouterLink>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TabArea from '@/components/TabArea'

export default {
    components: {
        //TabArea
    },
    data() {
        return {
            currentTab: 0,
            tab: [
                {
                    name: '전체'
                },
                {
                    name: '로그인/회원가입'
                },
                {
                    name: '가맹점 정보'
                },
                {
                    name: '결제/카드'
                },
                {
                    name: '사이트 이용'
                },
                {
                    name: '기타'
                }
            ],
            noticeTitle: '[신규제휴사] 글라이더스 오픈 안내',
            noticeDate: '2024. 07. 18',
            noticeContent: '관리자님,\n하이비타민 로그인 하려고 하는데.\n얼마전 회원가입을 했으나 없는 아이디라고 계속 창이 떠요.\n\n왜그런걸까요?\n다시 가입 하려 했으나 아이디는 이미 존재하고 있다고 하구요..\n해결 부탁드리겠습니다. \n\n\n감사합니다.',
            answerDate: '2024. 07. 25',
            answerContent: '고객님, 불편을 드려 죄송합니다.\n아이디 삭제 처리 해드렸으며, 다시 한번 재가입 진행해주시면 감사하겠습니다.',
            isTabActive: true
        }
    },
    setup() {
        const qnaTitle = sessionStorage.getItem('qnaTitle');
        const qnaRmks = sessionStorage.getItem('qnaRmks');
        const replyRmks = sessionStorage.getItem('replyRmks');
        const regDt = sessionStorage.getItem('regDt');
        const replyDt = sessionStorage.getItem('replyDt');

        return {
            qnaTitle,
            qnaRmks,
            replyRmks,
            regDt,
            replyDt
        };
    },
    methods: {
        changeTab(key) {
            this.currentTab = key
        }
    }
}
</script>

<style scoped>
.content-separator {
    margin: 20px 0;
    width: 100%;
}

.separator-line {
    width: 100%;
    height: 1px;
    background: repeating-linear-gradient(to right,
            #666 0px,
            #666 3px,
            transparent 3px,
            transparent 6px);
    /* 대안: 테두리 스타일 사용 */
    /* border-top: 1px dashed #666; */
}

/* 모바일 화면에서는 더 얇은 선 */
@media (max-width: 768px) {
    .separator-line {
        background: repeating-linear-gradient(to right,
                #666 0px,
                #666 2px,
                transparent 2px,
                transparent 4px);
    }
}

.original-question {
    margin-top: 15px;
    padding-top: 15px;
    line-height: 1.6;
    white-space: pre-line;
}
</style>